import React, { useState } from 'react'
import { ItemData } from "../../data";
import { Carousel } from 'react-responsive-carousel';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Link } from "react-router-dom";

export const Category = () => {
  // const [active, setActive] = useState([]);
  const [items] = useState(ItemData);
  const [banner] = useState(ItemData);
  const [wishlist, setWishlist] = useState([]);

  const onWishlistClick = (id) => {
    // if the item is already there in wishlist array, then remove it
    if (wishlist.includes[id]) {
      setWishlist(wishlist.filter(wid => wid !== id))
    } else {
      // else, add it to array
      setWishlist([...wishlist, id])
    }
  }

  return (
    <div className="w-full lg:w-4/5 mb-10">
      <div className="filter_bar bg-gray-200 flex pl-7 mb-6 py-2 justify-between pr-2 items-center">
        <div className="uppercase text-xs text-gray-600">EYEGLASSES</div>
        <div className="text-xs text-cyan-500 uppercase text-right">
          <i className="fa fa-sort-amount-asc"></i>SORT BY
          <select className="py-1 pl-2 pr-3 ml-2 border border-gray-300">
            <option value="">Best Seller</option>
            <option value="">Price: Low to high</option>
            <option value="">Price: high to Low</option>
            <option value="">New</option>
            <option value="">Bigest Saving</option>
            <option value="">Most Viewed</option>
          </select>
        </div>
      </div>
      <div className="pl-0 lg:pl-7">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {items.map((curElm) => {
            const { id, image, title, size, type, price, offer } = curElm;
            return (

              <div className="item_contcontainer border border-gray-200 rounded-lg hover:shadow-xl relative">
                {/* <span className={active === true ? "active absolute text-gray-600 wishlist" : "absolute text-gray-600 wishlist"} onClick={() => setActive((prevState) => !prevState)}></span> */}
                <span className={ wishlist.includes(curElm.id) ? 'active absolute text-gray-600 wishlist' : 'absolute text-gray-600 wishlist' } ></span>
                <Link to="/productdetail" key={id}>
                  <div className="pt-4 px-4">
                    <Carousel emulateTouch={true} showStatus={false} thumbWidth={50} infiniteLoop={true} stopOnHover={true} autoPlay={false} showIndicators={false}>
                      {banner.map((curElm) => {
                        return (
                          <img src={image} alt={title} />
                        );
                      })}
                    </Carousel>
                  </div>
                  <div className="px-4">
                    <h4 className="text-sm font-medium">{title}</h4>
                    <div className="flex justify-between">
                      <div className="text-xs font-light"><span className="size">Size: {size}</span> <span className="bullet">•</span> <span className="tags">{type}</span></div>
                      <div className="space-x-1">
                        {/* <Link to="#"><span className="color_option rounded-full w-4 h-4 inline-block" style={{background: color1}}></span></Link>
                          <Link to="#"><span className="color_option rounded-full w-4 h-4 inline-block" style={{background: color2}}></span></Link>
                          <Link to="#"><span className="color_option rounded-full w-4 h-4 inline-block" style={{background: color3}}></span></Link> */}
                        <div className="text-sm font-medium mb-3">${price}</div>
                      </div>
                    </div>
                    {/* <div className="text-sm font-medium mb-3">${price}</div> */}
                  </div>
                  <div className="product-offer-label">
                    <span className="product-offer-text">{offer}</span>
                  </div>
                </Link>
              </div>

            );
          })}

        </div>
      </div>
    </div>
  )
}